import { StrictMode, startTransition } from "react"
import { createRoot } from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import App from "./App.jsx"
import ErrorBoundary from "@/components/common/ErrorBoundary"
import "@/styles/main.scss"
import "photoswipe/dist/photoswipe.css"
import "rc-slider/assets/index.css"

function onIdle(cb, timeout = 1200) {
  if ("requestIdleCallback" in window)
    return requestIdleCallback(cb, { timeout })
  return setTimeout(cb, timeout)
}

function watchLongTasks(enabled = false) {
  if (!enabled || !("PerformanceObserver" in window)) return
  try {
    const po = new PerformanceObserver(() => { })
    po.observe({ type: "longtask", buffered: true })
  } catch { }
}
watchLongTasks(import.meta?.env?.DEV)

const rootEl = document.getElementById("root")
const preloaderEl = document.getElementById("preloader")

if (rootEl && getComputedStyle(rootEl).opacity === "1") {
  rootEl.style.opacity = "0"
  rootEl.style.transition = "opacity 250ms ease"
}

const root = createRoot(rootEl)

startTransition(() => {
  root.render(
    <StrictMode>
      <HelmetProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </HelmetProvider>
    </StrictMode>
  )
})

let revealed = false
function reveal() {
  if (revealed) return
  revealed = true

  onIdle(() => {
    if (rootEl) rootEl.style.opacity = "1"
    if (preloaderEl) {
      preloaderEl.style.transition = "opacity 250ms ease"
      preloaderEl.style.opacity = "0"
      setTimeout(() => preloaderEl.remove(), 260)
    }
  })
}

let idleHandle = null

if ("requestIdleCallback" in window) {
  const onLoad = () => {
    idleHandle = onIdle(reveal, 1500)
    window.removeEventListener("load", onLoad)
  }
  window.addEventListener("load", onLoad, { once: true })
} else {
  window.addEventListener(
    "load",
    () => {
      setTimeout(reveal, 150)
    },
    { once: true }
  )
}

if (document.readyState === "complete") reveal()
else window.addEventListener("load", reveal, { once: true })
